export default __webpack_public_path__ + "static/media/machine-ic-light.3d8e4d5f.svg";